/**
 * @file A Game's player selector
 * @author Gonzalo Alvarez de Aldecoa <gon@galdecoa.com>
 * @license GPL-3.0-or-later
 * @version 2312.10.001
 */

/** @module gameplayerselector */

import { Sprite } from "./Sprite.js";
import { SpriteViewer } from "./SpriteViewer.js";

const spriteOptions = {
	animationInterval: 200,
	movementArea: { x: 0, width: 0, y: 0, height: 0 }
};
const spriteViewers = {};

/**
 * Initialise the player character selector.
 * @param {HTMLElement} container 
 * @param {module:game~Game} game 
 */
export function initialisePlayerSelector( container, game ) {
	const playerChoiceElement = container.querySelector( ".player-choice" );
	const playerChoiceItems = playerChoiceElement.querySelectorAll( "li" );
	const checkedInput = container.querySelector( "input:checked" );
	const checkedCharacter = checkedInput.value;
	const storedCharacter = localStorage && localStorage.getItem( "character" );
	if ( !storedCharacter && localStorage ) {
		localStorage.setItem( "character", checkedCharacter );
	}
	const selectedSprite = storedCharacter || checkedCharacter;
	for ( let i = playerChoiceItems.length - 1; i >= 0; i = i - 1 ) {
		const item = playerChoiceItems[ i ];
		const input = item.querySelector( "input" );
		input.checked = ( input.value == selectedSprite );
		const canvas = item.querySelector( "canvas" );
		const image = game.images.main[ "character" + input.value ];
		const sprite = new Sprite( 0, 0, 64, 80, image, spriteOptions );
		spriteViewers[ input.value ] = new SpriteViewer( canvas, sprite );
		spriteViewers[ input.value ].isAnimated = input.checked;
		if ( input.checked ) { game.changePlayerSprite( image ); }
		input.addEventListener( "click", function( clickEvent ) {
			game.changePlayerSprite( image );
			for( let spriteViewerKey in spriteViewers ) {
				const spriteViewer  = spriteViewers[ spriteViewerKey ];
				spriteViewer.isAnimated = (
						 clickEvent.target.checked
					&& ( spriteViewerKey === clickEvent.target.value )
				);
				if ( !localStorage || !spriteViewer.isAnimated )  { continue; }
				localStorage.setItem( "character", spriteViewerKey );
			}
		} );
	}
}